/**
 * Where to go after signing in. Kept in localStorage, not sessionStorage,
 * because an email sign-in link opens in a new tab.
 */
const KEY = "dayax:after-login";
const MAX_AGE_MS = 60 * 60 * 1000;

export function rememberReturnTo(path: string) {
  if (path === "/" || path.startsWith("/login") || path.startsWith("/onboarding")) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {
    // Storage blocked: people land on the home page instead.
  }
}

/** Returns the remembered path and forgets it, if `accept` takes it. */
export function takeReturnTo(accept: (path: string) => boolean = () => true): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw) as { path?: unknown; at?: unknown };
    const valid = typeof path === "string" && path.startsWith("/") && !path.startsWith("//") && typeof at === "number" && Date.now() - at < MAX_AGE_MS;
    if (valid && !accept(path)) return null;
    localStorage.removeItem(KEY);
    return valid ? path : null;
  } catch {
    return null;
  }
}
